<div class="error-container">
  <div class="error-container-details">
    <div>
      <img src="{{ 'assets/images/error-icons/' + errorStatusCode + '.svg' }}" width="100%" alt="error icon">

      @if (errorStatusCode === '401') {
        <p i18n="@@Common.GlobalError.UnauthorizedErrorTitle">Unauthorized</p>
        <p i18n="@@Common.GlobalError.UnauthorizedErrorMessage">Access is allowed only for Registered Users
                </p>
      } @else {
        @if (errorStatusCode === '403') {
          <p i18n="@@Common.GlobalError.ForbiddenErrorTitle">Forbidden</p>
          <p i18n="@@Common.GlobalError.ForbiddenErrorMessage">You don’t have permission to access this
                        content
                    </p>
        } @else {
          @if (errorStatusCode === '404') {
            <p i18n="@@Common.GlobalError.NotFoundErrorTitle">Page not found</p>
            <p i18n="@@Common.GlobalError.NotFoundErrorMessage">We can’t find the page that you’re looking for
                    </p>
          } @else {
            <p i18n="@@Common.GlobalError.InternalServerErrorTitle">Internal Server Error</p>
            <p i18n="@@Common.GlobalError.InternalServerErrorMessage">We’re experiencing an Internal Server Problem.
                    Please try again later
                </p>
          }
        }
      }



      @if (isViewErrorButtonRequired) {
        <button
          mat-button
          color="accent"
          [attr.id]="buildGlobalErrorId('btn-view-error')"
        (click)="onViewError()">View Error</button>
      }
      @if (isNavigateBackRequired) {
        <button
          mat-button
          color="accent"
          class="ghost"
          [attr.id]="buildGlobalErrorId('btn-go-back')"
          (click)="navigateBack()">Go
        Back</button>
      }
    </div>
  </div>
</div>
